import { render, staticRenderFns } from "./CompanyNotificationFlow.vue?vue&type=template&id=5f828906&scoped=true"
import script from "./CompanyNotificationFlow.vue?vue&type=script&lang=js"
export * from "./CompanyNotificationFlow.vue?vue&type=script&lang=js"
import style0 from "./CompanyNotificationFlow.vue?vue&type=style&index=0&id=5f828906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f828906",
  null
  
)

export default component.exports